import 'styles/global.scss';

// TODO #1 Can this be done better?
// - Need to ensure the global listener is set as soon as possible.
// - Import some other file, that is intended to be loaded on init and separate `iFrameResizerChild`
//   which will use this file "under the hood".
import './iframes/iFrameResizerChild';

import ReactDOM from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';

import App from './App';

// Polyfill the ResizeObserver, it will use the native implementation if present.
window.ResizeObserver = ResizeObserver;

ReactDOM.render(<App />, document.getElementById('root'));
